import { gql } from '@apollo/client';


export const GET_POLICIES = gql`
  query GetPolicies($filter: InsurancePoliciesFilterInput) {
  getPolicies(filter: $filter) {
      _id 
    firstName
    lastName
    phoneNumber
    vendorName
    FFMId
    memberId
    officeId
    office {
      officeName
      
    }
    user {
      firstName
      lastName
    }
    majorMed {
      _id
      carrier
      isPostDate
      billingDate
      premium
      status
    }
    privateMed {
      _id
      isPostDate
      billingDate
      carrier
      premium
      status
    }
    ancillaries {
      _id
      carrier
      isPostDate
      billingDate
      premium
      status
    }
    address {
      _id
      aptUnite
      city
      country
      state
      street
      zipCode
    }
  }
}`;

export interface PolicyItem {
    _id: string;
     carrier: string;
    isPostDate: boolean;
    billingDate: string;
    premium: number;
    status: string;
}

export interface Address {
    _id: string;
    aptUnite: string;
    city: string;
    country: string;
    state: string;
    street: string;
    zipCode: string;
}

export interface Policy {
    _id: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    vendorName: string;
    officeId: string;
    FFMId: string;
    memberId: string;
    office: {
        officeName: string;
    };
    userId: string;
    user: {
        firstName: string;
        lastName: string;
    };
    majorMed: PolicyItem;
    privateMed: PolicyItem;
    ancillaries: PolicyItem[];  

    address: Address;
}   
export interface  InsurancePoliciesFilterInput{
    officeId?: string;
    userId?: string;
    startDate?: string;
    endDate?: string;
    isPostDate?: boolean;
    request?: boolean;
    status?: string;
} 